export default {
  desktop: 1024,
  tablet: 768,
  phone: 480,
};



// WEBPACK FOOTER //
// ./src/config/index.js